import { useState } from 'react';

/**
 * Custom hook for managing relationship split pane state in AdminDashboard
 * 
 * @returns {Object} Object containing relationship state and setters
 */
export const useRelationshipState = () => {
    // Split pane states for relationships
    const [relViewMode, setRelViewMode] = useState('user'); // 'user' or 'organization'
    const [leftSearch, setLeftSearch] = useState('');
    const [selectedId, setSelectedId] = useState(null);
    const [searchAssign, setSearchAssign] = useState('');
    const [isAssignDropdownOpen, setIsAssignDropdownOpen] = useState(false);

    return {
        relViewMode,
        setRelViewMode,
        leftSearch,
        setLeftSearch,
        selectedId,
        setSelectedId,
        searchAssign,
        setSearchAssign,
        isAssignDropdownOpen,
        setIsAssignDropdownOpen
    };
};
